import { Fragment } from "react";
import styles from "@/components/mvp/DemoOfferReprezentacyjna.module.css";

type DemoOfferReprezentacyjnaProps = {
  onClose: () => void;
};

const costSections = [
  {
    title: "Prace przygotowawcze",
    rows: [
      ["Zabezpieczenie podłóg i stolarki", "75", "m²", "8 zł", "600 zł"],
      ["Demontaż starych listew", "95", "mb", "6 zł", "570 zł"],
    ],
  },
  {
    title: "Gładzie i malowanie",
    rows: [
      ["Gruntowanie ścian", "310", "m²", "8 zł", "2 480 zł"],
      ["Gładź gipsowa 2 warstwy poziom Q3", "310", "m²", "52 zł", "16 120 zł"],
      ["Gruntowanie sufitów", "75", "m²", "8 zł", "600 zł"],
      ["Malowanie ścian farba Dulux 2 warstwy", "310", "m²", "28 zł", "8 680 zł"],
      ["Malowanie sufitów", "75", "m²", "24 zł", "1 800 zł"],
      ["Odcięcie kolorów przedpokój + salon", "35", "mb", "18 zł", "630 zł"],
    ],
  },
  {
    title: "Podłogi",
    rows: [
      ["Wylewka samopoziomująca", "68", "m²", "62 zł", "4 216 zł"],
      ["Panele SPC rigid core 5mm", "68", "m²", "115 zł", "7 820 zł"],
      ["Listwy przypodłogowe MDF", "110", "mb", "14 zł", "1 540 zł"],
      ["Progi i przejścia", "4", "szt.", "85 zł", "340 zł"],
    ],
  },
  {
    title: "Łazienka (6 m²)",
    rows: [
      ["Hydroizolacja 2 warstwy + taśmy", "18", "m²", "58 zł", "1 044 zł"],
      ["Płytki ścienne 60×120 rektyfikowane", "22", "m²", "110 zł", "2 420 zł"],
      ["Płytki podłogowe 60×60", "6", "m²", "95 zł", "570 zł"],
      ["Fuga epoksydowa", "28", "m²", "32 zł", "896 zł"],
      ["Biały montaż WC wisząca + umywalka + kabina", "1", "kpl", "2 200 zł", "2 200 zł"],
    ],
  },
  {
    title: "Elektryka",
    rows: [
      ["Punkty elektryczne", "28", "szt.", "115 zł", "3 220 zł"],
      ["Podłączenie osprzętu Legrand Niloe", "28", "szt.", "85 zł", "2 380 zł"],
    ],
  },
  {
    title: "Prace wykończeniowe",
    rows: [
      ["Silikonowanie i uszczelnienia", "1", "kpl", "680 zł", "680 zł"],
      ["Sprzątanie końcowe", "1", "kpl", "950 zł", "950 zł"],
    ],
  },
];

export function DemoOfferReprezentacyjna({ onClose }: DemoOfferReprezentacyjnaProps) {
  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-label="Podgląd oferty reprezentacyjnej">
      <button type="button" className={styles.close} onClick={onClose}>
        × Zamknij
      </button>

      <div className={styles.shell}>
        <article className={`${styles.page} ${styles.cover}`}>
          <div className={`${styles.annotation} ${styles.coverNote}`}>
            <span className={styles.dot} />
            <span className={styles.line} />
            <span className={styles.label}>Okładka projektu</span>
          </div>
          <div className={styles.logo}>Logo</div>
          <p className={styles.coverLabel}>Oferta reprezentacyjna</p>
          <h1>Mieszkanie Mokotów</h1>
          <p className={styles.address}>Marek i Karolina Zając · ul. Puławska 156 m. 12, Warszawa Mokotów</p>
          <div className={styles.coverRule} />
          <span>Wartość oferty</span>
          <strong>73 254 zł brutto</strong>
          <div className={styles.coverMeta}>
            <div><span>Data</span><b>11.07.2025</b></div>
            <div><span>Gwarancja</span><b>36 mies.</b></div>
            <div><span>Termin</span><b>7-8 tygodni</b></div>
          </div>
        </article>

        <article className={styles.page}>
          <div className={`${styles.annotation} ${styles.summaryNote}`}>
            <span className={styles.dot} />
            <span className={styles.line} />
            <span className={styles.label}>Streszczenie przed kosztorysem</span>
          </div>
          <p className={styles.kicker}>Executive summary</p>
          <h2>Co wykonamy</h2>
          <ul className={styles.summaryList}>
            <li>Kompleksowe wykończenie 4-pokojowego mieszkania (75 m²)</li>
            <li>Gładzie gipsowe Q3 przygotowane pod malowanie premium</li>
            <li>Podłogi SPC kompatybilne z ogrzewaniem podłogowym</li>
            <li>Łazienka z hydroizolacją i płytkami rektyfikowanymi</li>
            <li>Elektryka: 28 punktów z osprzętem Legrand Niloe</li>
          </ul>
          <div className={styles.cards}>
            <div><span>Wartość</span><strong>73 254 zł brutto</strong></div>
            <div><span>Materiały</span><strong>po stronie wykonawcy</strong></div>
            <div><span>Gwarancja</span><strong>36 miesięcy</strong></div>
            <div><span>Termin</span><strong>7-8 tygodni</strong></div>
          </div>
        </article>

        <article className={styles.page}>
          <div className={`${styles.annotation} ${styles.milestoneNote}`}>
            <span className={styles.dot} />
            <span className={styles.line} />
            <span className={styles.label}>Harmonogram z płatnościami etapowymi</span>
          </div>
          <p className={styles.kicker}>Plan realizacji</p>
          <h2>Harmonogram</h2>
          <table className={styles.milestones}>
            <tbody>
              <tr><td>Tydzień 1-2</td><td>Gładzie, gruntowanie</td><td>25% płatność po etapie</td></tr>
              <tr><td>Tydzień 3-4</td><td>Malowanie, wylewki</td><td>-</td></tr>
              <tr><td>Tydzień 5-6</td><td>Podłogi, łazienka</td><td>25% płatność po etapie</td></tr>
              <tr><td>Tydzień 7</td><td>Elektryka, osprzęt, wykończenia</td><td>-</td></tr>
              <tr><td>Tydzień 8</td><td>Odbiór końcowy, protokół</td><td>25% płatność po odbiorze</td></tr>
            </tbody>
          </table>
        </article>

        <article className={styles.page}>
          <div className={`${styles.annotation} ${styles.sectionNote}`}>
            <span className={styles.dot} />
            <span className={styles.line} />
            <span className={styles.label}>Kosztorys w sekcjach</span>
          </div>
          <p className={styles.kicker}>Kosztorys szczegółowy</p>
          <h2>Zakres prac</h2>
          <CostTable sections={costSections.slice(0, 3)} />
        </article>

        <article className={styles.page}>
          <CostTable sections={costSections.slice(3)} />
          <section className={styles.totalBox}>
            <div><span>Razem netto</span><strong>59 556 zł</strong></div>
            <div><span>VAT 23%</span><strong>13 698 zł</strong></div>
            <div><span>Razem brutto</span><strong>73 254 zł</strong></div>
          </section>
          <section className={styles.terms}>
            <div>
              <h3>Płatność etapami</h3>
              <p>25% zaliczka przed startem · 25% po gładziach · 25% po podłogach i łazience · 25% po odbiorze.</p>
              <h3>Założenia</h3>
              <p>Mieszkanie w stanie deweloperskim, dostęp 8:00-18:00 pn-pt, wywóz odpadów po stronie wykonawcy.</p>
              <h3>Wyłączenia</h3>
              <p>Meble i AGD, armatura łazienkowa dostarczana przez klienta, roboty balkonowe.</p>
            </div>
            <div className={styles.cta}>
              <button type="button">Akceptuję ofertę</button>
              <p>Kontakt wykonawcy: biuro@wykonawca.pl · 600 000 000</p>
            </div>
          </section>
        </article>
      </div>
    </div>
  );
}

function CostTable({
  sections,
}: {
  sections: Array<{ title: string; rows: string[][] }>;
}) {
  return (
    <table className={styles.costTable}>
      <thead>
        <tr>
          <th>Pozycja</th>
          <th>Ilość</th>
          <th>Jedn.</th>
          <th>Cena jedn.</th>
          <th>Wartość netto</th>
        </tr>
      </thead>
      <tbody>
        {sections.map((section) => (
          <Fragment key={section.title}>
            <tr className={styles.sectionRow}>
              <td colSpan={5}>SEKCJA: {section.title}</td>
            </tr>
            {section.rows.map(([name, qty, unit, price, total]) => (
              <tr key={`${section.title}-${name}`}>
                <td>{name}</td>
                <td>{qty}</td>
                <td>{unit}</td>
                <td>{price}</td>
                <td>{total}</td>
              </tr>
            ))}
          </Fragment>
        ))}
      </tbody>
    </table>
  );
}
